import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_ARTICLE_COUNTRY_TAXES,
    FAILURE_ARTICLE_GROUP,
    FAILURE_GROUP_REBATES,
    REQUEST_ARTICLE_COUNTRY_TAXES,
    REQUEST_ARTICLE_GROUP,
    REQUEST_GROUP_REBATES,
    SUCCESS_ARTICLE_COUNTRY_TAXES,
    SUCCESS_ARTICLE_GROUP,
    SUCCESS_GROUP_REBATES,
} from './actions';

export function articleArticleGroupReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_GROUP:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_GROUP:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_GROUP:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function articleGroupRebateReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_GROUP_REBATES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_GROUP_REBATES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_GROUP_REBATES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function articleGroupCountryTaxReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ARTICLE_COUNTRY_TAXES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ARTICLE_COUNTRY_TAXES:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ARTICLE_COUNTRY_TAXES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
